import { createSelector } from 'reselect';
import i18n from 'i18n';

export const selectSearch = (state) => state.search;

export const selectSearchResultData = createSelector(selectSearch, (search) => search.results);

export const selectIsLoading = createSelector(selectSearch, (search) => search.isLoading);

export const selectSearchInitialQuery = createSelector(selectSearch, (search) => search.query);

export const selectSearchResultItems = createSelector(
  selectSearchResultData,
  (searchResultData) => searchResultData && searchResultData.content,
);

export const selectSearchResult = createSelector(selectSearchResultData, (searchResultData) => {
  if (!searchResultData) return;

  const previewItemsCount = 5;
  const { content: allItems, totalElements: totalItemsCount } = searchResultData;

  return {
    ...searchResultData,
    previewItems:
      allItems &&
      allItems.slice(0, previewItemsCount).concat(
        totalItemsCount > previewItemsCount && allItems.length >= previewItemsCount
          ? [
              {
                type: 'VIEW_ALL',
                id: 'view-all',
                title: i18n.t('common.watchAllButton'),
                titles: {
                  UA: i18n.t('common.watchAllButton'),
                  EN: i18n.t('common.watchAllButton'),
                },
              },
            ]
          : [],
      ),
    previewItemsCount,
  };
});
